


























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { Getter } from 'vuex-class';

import { mapGetters } from 'vuex';
import { Topic } from '../../../models/topic';
import { Option } from '../../../models/option';
import { Configuration } from '../../../models/configuration';

@Component({

})
export default class QuestionBox extends Vue {

    // Data
    private selectedOption: Option | null = null;
    private isModalActive: boolean = false;

    // Props
    @Prop() private topic: Topic;

    // Vuex Getters
    @Getter('topic/activeTopic') private activeTopic: Topic;
    @Getter('configuration/values') private values: number[];
    @Getter('configuration/configuration') private configuration: Configuration;
    @Getter('topic/selectedOptions') private selectedOptions: Option[];
    @Getter('topic/topics') private topics: Topic[];

    @Watch('configuration')
    private onValuesChanged() {
        // If the options in the configuration are empty, remove the selected option
        if (this.configuration.options.length === 0) {
            this.selectedOption = null;
        }
    }

    // Methods
    private optionSelected(topic: Topic, option: Option) {

        this.selectedOption = option;

        const data = {
            option,
            topic_id: topic.id,
        };

        this.$store.commit('configuration/addOption', data);

        // When the user has answered, open the next question
        if (topic.id !== this.topics.length) {
            this.setActiveTopic(this.topics[topic.id]);
        }
    }

    private isOptionSelected(option: Option) {
        return this.configuration.options.find((answeredOption) => {
            if (answeredOption.id === option.id) {
                this.selectedOption = option;
                return true;
            } else {
                return false;
            }
        });
    }

    private setActiveTopic(topic: Topic) {
        this.$store.commit('topic/setActiveTopic', topic);
    }

    private isAnswered() {
        return (this.selectedOption != null);
    }

    private toggleInfoModal(event) {
        // event.preventDefault();
        // event.stopImmediatePropagation();
        this.isModalActive = !this.isModalActive;
    }
}
